/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import BaseApi from '../api/BaseApi';
import {SettingsApi as Contract, Parameters, Settings, SettingsLevel, SettingsResponse} from '@adobe/exc-app/settings';
import {Events} from '@exc/shared';
import Metrics from '../metrics';

type Handler = <T extends Settings>(reqParams: Parameters<T>) => Promise<SettingsResponse<T>>;

export class SettingsApi extends BaseApi implements Contract {
  protected keyPrefix = 'settings';
  public SETTINGS_LEVEL = SettingsLevel;
  public get: Handler = this.handler<Parameters<any>, SettingsResponse<any>>('GET');
  public set: Handler = this.handler<Parameters<any>, SettingsResponse<any>>('POST');
  protected metrics = Metrics.create('exc.module-runtime.settings');
  protected logPrefix = 'RuntimeSettings';
  protected apiEvents = ['settings'];
  protected defaultType = 'settings';
  protected event = Events.EXC_SETTINGS;
}
